/* eslint-disable no-unused-vars */
import Vue from "vue";
import App from "./App";
import router from "./router";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import vSelect from "vue-select";
import VueFilterDateFormat from "@vuejs-community/vue-filter-date-format";
import VueCurrencyInput from "vue-currency-input";
import Vuelidate from "vuelidate";

import store from "./core/store";
import CorePlugins from "./core/plugins";

import "vue-notifyjs/themes/default.css";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import "./globals.css";

import { withoutLogin } from "./core/api";

Vue.use(CorePlugins);

Vue.use(BootstrapVue, {
  BTooltip: {
    trigger: 'hover'
  }
});
Vue.use(IconsPlugin);
Vue.component("v-select", vSelect);
Vue.use(VueFilterDateFormat, {
  dayOfWeekNames: [ "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado" ], // prettier-ignore
  dayOfWeekNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"], // prettier-ignore
  monthNames: [ "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro" ], // prettier-ignore
  monthNamesShort: [ "Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez" ], // prettier-ignore
  timezone: -3,
});



Vue.use(VueCurrencyInput, {
  globalOptions: { currency: "BRL" },
});
Vue.use(Vuelidate);

/* eslint-disable no-new */
new Vue({ router, store, render: (h) => h(App) }).$mount("#app");
